import { useMemo } from "react";

import { useDLMApplicationView } from "../../context/DLMApplicationViewProvider";
import { getDLMApplicationTypeText, getDLMWorkflowCode } from "../../_helpers";
import { 
  DetailCard,
  DetailFileDownload,
  DetailItem,
  DetailLabelKeysToCells,
  DetailLabelKeysToFiles,  
} from "../../../../../components/layout"
import { fieldChanged, showDate } from "../../../../../components/helpers";


const DLM_DETAILS_COMMON_FIELDS = {  
  hourRating: 'Hour Rating',
  totalLabelQuantity: 'Total Label Quantity',
}

const DLM_RESULT_ATTACHMENTS = {
  labTestResult: 'Lab Test Result'
}

const ApplicationDetails = () => {

  const { dlmAppData: dat } = useDLMApplicationView();

  const { appTypeText, workflow } = useMemo(() => {
    if (dat === undefined) return { workflow: '', appTypeText: ''};

    const { applicationType, dlmType } = dat;
    const workflow = getDLMWorkflowCode(dat);
    const appTypeText = getDLMApplicationTypeText(applicationType, dlmType);

    return { workflow, appTypeText };
  }, [dat])

  if (dat === undefined) {
      return null;
  }

  return(
  <DetailCard cardTitle="Application Details">
    <DetailItem labelText="Application Type" content={`${appTypeText} ${dat.applicationType === 'TYPE_APPLICATION' ? '- ' + workflow : ''}`} hasChanged={fieldChanged(dat, 'applicationType')} />
    <DetailItem labelText="Model" content={`${dat.model}`} hasChanged={fieldChanged(dat, 'model')}  />        
    { (dat?.labelSet && dat.labelSet?.id > 0) &&
    <DetailItem labelText="Label Set" content={`${dat.labelSet.name}`} hasChanged={fieldChanged(dat.labelSet, 'name')}/>  
    } 
    {DetailLabelKeysToCells(DLM_DETAILS_COMMON_FIELDS, dat, false, true)}
    
    { (dat?.disclaimerAck) && 
    <DetailItem labelText="Disclaimer Acknowledged" >
      <div className='form-check form-check-sm form-check-custom form-check-solid'>
        <input className='form-check-input pe-none' type='checkbox' checked readOnly />
      </div>
    </DetailItem>
    }      
    { (appTypeText === 'Trigger Test') &&
    <DetailItem labelText="Sampling Location" content={`${dat?.samplingLocation ? dat.samplingLocation : ''}`} hasChanged={fieldChanged(dat, 'samplingLocation')} />  
    }              

    {(dat?.poNO || dat?.podo) && 
    <>
    <div className='separator border-gray-200 mb-2'></div>
    {(dat?.poNO) &&     
    <DetailItem labelText="PO No." content={dat.poNO} hasChanged={fieldChanged(dat, 'poNO')} />  
    }
    {(dat?.podo) &&     
    <DetailFileDownload labelText="PO" file={dat?.podo} hasChanged={fieldChanged(dat, 'podo')}/>        
    }
    </>
    }

    <div className='separator border-gray-200 mb-2'></div>
    { (dat?.inspectionDate) &&
    <>
    <DetailItem labelText={ ['Label1b2','Label1b3'].includes(workflow) ? 'Component Check Date' : "Inspection Date"} hasChanged={fieldChanged(dat, 'inspectionDate')}>
      {showDate(dat.inspectionDate, 'inspectionDate')}
    </DetailItem>
    { (dat?.inspectionBy && dat.inspectionBy?.name) &&
    <DetailItem labelText="Inspection Inspector" >
      {dat.inspectionBy.name}
    </DetailItem>    
    }
    </>
    }
    { (dat?.samplingDate) &&
    <>
    <DetailItem labelText="Sampling Date" hasChanged={fieldChanged(dat, 'samplingDate')}>
      {showDate(dat.samplingDate, 'inspectionDate')}
    </DetailItem>    
    { (dat?.inspectionBy && dat.inspectionBy?.name) &&
    <DetailItem labelText="Sampling Inspector" >
      {dat.inspectionBy.name}
    </DetailItem>    
    }
    </>
    }
    {DetailLabelKeysToFiles(DLM_RESULT_ATTACHMENTS, dat, false, false, true)}
      
  </DetailCard>
  )
}

export { ApplicationDetails } 